import React from "react";
import { Routes } from "../config";
const App = () => {
  return <Routes />;
};

export default App;
